(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/focus-trap/assets/javascripts/use-focus-trap.js') >= 0) return;  svs.modules.push('/components/lb-utils/focus-trap/assets/javascripts/use-focus-trap.js');

'use strict';

const {
  useEffect,
  useCallback,
  useMemo,
  useRef
} = React;
const {
  constants
} = svs.components.lbUtils.focusTrap;
const logger = svs.core.log.getLogger('components:lb-utils:focus-trap:use-focus-trap');

const useFocusTrap = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const selectors = useMemo(() => {
    var _options$selectors;
    return (_options$selectors = options.selectors) !== null && _options$selectors !== void 0 ? _options$selectors : constants.defaultSelectors;
  }, [options]);
  const refocus = useMemo(() => {
    var _options$refocus;
    return (_options$refocus = options.refocus) !== null && _options$refocus !== void 0 ? _options$refocus : true;
  }, [options]);
  const trapRef = useRef(constants.state);

  const trapFocus = useCallback(function (target, cb) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!target) {
      throw new Error('No target element provided');
    }
    const queryString = selectors.join(',');
    let elements = [...target.querySelectorAll(queryString)].filter(el => el.hasAttribute('tabindex') ? el.tabIndex > -1 : true);
    if (options.addTabBefore) {
      elements = options.addTabBefore.concat(elements);
    }
    if (options.addTabAfter) {
      elements = elements.concat(options.addTabAfter);
    }
    if (elements.length === 0) {
      logger.warn('No focusable elements found inside the target');
      return;
    }
    trapRef.current.target = target;
    trapRef.current.focusableElements = elements;
    trapRef.current.first = elements[0];
    trapRef.current.last = elements[elements.length - 1];
    trapRef.current.initiator = document.activeElement;
    requestAnimationFrame(() => {
      if (trapRef.current.first) {
        trapRef.current.first.focus();
      }
      cb === null || cb === void 0 || cb({
        el: target,
        focusableElements: elements
      });
    });
  }, [selectors]);

  const releaseFocus = useCallback((newFocusEl, cb) => {
    const {
      target,
      initiator
    } = trapRef.current;
    const elementToFocus = newFocusEl || (refocus ? initiator : null);

    trapRef.current.target = null;
    trapRef.current.focusableElements = [];
    trapRef.current.first = null;
    trapRef.current.last = null;
    if (elementToFocus) {
      requestAnimationFrame(() => {
        elementToFocus.focus();
      });
    }
    cb === null || cb === void 0 || cb({
      el: target,
      newFocus: elementToFocus
    });
  }, [refocus]);
  useEffect(() => {
    const handleKeyDown = e => {
      const {
        first,
        last,
        target,
        initiator
      } = trapRef.current;
      if (!target) {
        return;
      }
      if (e.key === 'Tab') {
        if (document.activeElement === first && e.shiftKey) {
          e.preventDefault();
          last.focus();
        }
        if (document.activeElement === last && !e.shiftKey) {
          e.preventDefault();
          first.focus();
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        if (options.onEscape) {
          options.onEscape();
        } else {
          releaseFocus(initiator);
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [options, releaseFocus]);
  return {
    trapFocus,
    releaseFocus
  };
};
setGlobal('svs.components.lbUtils.useFocusTrap', useFocusTrap);

 })(window);